import Modal from '../../shared/components/Modal';
import VooksLogo from '../../resources/images/vooks_logo.png';

const VooksApplicationResultModal = ({ showApplicationResultModal, closeApplicationResultModal, message }) => {
  return (
    <Modal show={showApplicationResultModal} closeModal={closeApplicationResultModal}>
      <div className={'max-w-[300px]'}>
        <div className={'flex justify-center'}>
          <div className={'w-[100px]'}>
            <img src={VooksLogo} alt={'VooksLogo'}/>
          </div>
        </div>
        <div className={'font-[nanum-square-b] mt-[20px]'}>
          {message}
        </div>
      </div>
    </Modal>
  );
};

export default VooksApplicationResultModal;
